// extracted by mini-css-extract-plugin
module.exports = {"points":"CheckList_points___oBNW","point":"CheckList_point__qLI97","pointIcon":"CheckList_pointIcon__WyEzX","text":"CheckList_text__XqPhj"};